import { useEffect } from 'react'
import { Button, Form, Input, Select, Checkbox } from 'mk-pc'
import { useMessage } from '@mkmp/core'
import { queryNavDataScope, updateNavDataScope } from '../../service'
import DataScopeOptions from './DataScopeOptions.json'
import './DataScopeList.scss'

interface Props {
  value?: any
}

/**
 * 导航数据权限点
 * @returns
 */
export const DataScopeList: React.FC<Props> = (props) => {
  const { messageApi } = useMessage()
  const { value } = props

  const [form] = Form.useForm()

  const inputChecked = Form.useWatch('deptChecked', form)

  useEffect(() => {
    if (!value || !value.id) return

    fetchFunction()
  }, [value])

  /**
   * 加载详情
   */
  const fetchFunction = async () => {
    if (!value || !value.id) return
    const result = await queryNavDataScope(value.id)
    if (result && result[0]) {
      form.setFieldsValue({
        ...result[0],
        deptChecked: result[0].dataType === 'dept'
      })
    } else {
      form.setFieldsValue({
        deptChecked: false,
        dataCode: '',
        dataName: '',
        dataOption: '',
        dataType: null
      })
    }
  }

  /**
   * 提交数据
   */
  const handleSubmit = async () => {
    const { deptChecked, dataType, dataCode } = await form.validateFields()

    const params: any = {
      navId: value.id
    }
    if (deptChecked && dataType === 'dept') {
      params.dataCode = dataCode
      params.dataName = (DataScopeOptions as any)[dataType].name
      params.dataType = dataType
      params.dataOption = JSON.stringify((DataScopeOptions as any)[dataType].options)
    }

    await updateNavDataScope(params)
    messageApi.open({
      type: 'success',
      content: '数据权限保存成功',
      duration: 2
    })
  }

  return (
    <section className="datascopelist">
      <header className="datascopelist-form__header">
        <Button type="primary" onClick={handleSubmit}>
          保存
        </Button>
      </header>
      <Form form={form} name="datascopelist-form" className="datascopelist-form" autoComplete="off" initialValues={{ items: [{}] }}>
        <div className="datascopelist-form__item">
          <Form.Item name="deptChecked" valuePropName="checked">
            <Checkbox />
          </Form.Item>
          <Form.Item label="权限码" name="dataCode" rules={[{ required: true, message: '请输入权限码' }]}>
            <Input disabled={!inputChecked} placeholder="权限码" />
          </Form.Item>
          <Form.Item label="权限类型" name="dataType" rules={[{ required: true, message: '请选择权限类型' }]}>
            <Select
              style={{ width: '100%' }}
              disabled={!inputChecked}
              options={[{ value: 'dept', label: '查看数据范围' }]}
              placeholder="选择数据权限"
            />
          </Form.Item>
        </div>
      </Form>
    </section>
  )
}
